// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Other/Reports.js/Reports.css */


.reports-title {
    color: #EF6F53;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    letter-spacing: 0.05rem;
    padding: 0.15rem;
    text-transform: uppercase;
}


.date-pickerr{
   margin: 2rem; 
}

.date-pickerr label{
    margin-right: 0.5rem;
}


    

`, "",{"version":3,"sources":["webpack://./src/components/routes/Other/Reports/Reports.css"],"names":[],"mappings":"AAAA,uDAAuD;;;AAGvD;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;AAC7B;;;AAGA;GACG,YAAY;AACf;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":["/* src/components/routes/Other/Reports.js/Reports.css */\n\n\n.reports-title {\n    color: #EF6F53;\n    text-align: center;\n    font-size: 1.5rem;\n    font-weight: bold;\n    letter-spacing: 0.05rem;\n    padding: 0.15rem;\n    text-transform: uppercase;\n}\n\n\n.date-pickerr{\n   margin: 2rem; \n}\n\n.date-pickerr label{\n    margin-right: 0.5rem;\n}\n\n\n    \n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
